import { render, staticRenderFns } from "./trackingcollector.vue?vue&type=template&id=f95180e8&scoped=true&"
import script from "./trackingcollector.vue?vue&type=script&lang=js&"
export * from "./trackingcollector.vue?vue&type=script&lang=js&"
import style0 from "./trackingcollector.vue?vue&type=style&index=0&id=f95180e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95180e8",
  null
  
)

export default component.exports